import { httpClient } from "../http/httpClient";
import { PartnerType } from "@/app/utils/partners.enum";
import { TriStateEnum } from "@/app/entities/TriState";

export type ExternalAlert = {
  active: boolean;
  title: string;
  subtitle: string;
  cta?: string;
  block: boolean;
  image?: string;
};

export type IExternalProduct = {
  active: boolean;
  alert?: ExternalAlert;
  color?: string;
  title?: string;
  subtitle?: string;
  image?: string;
  imageBlack?: string;
  description?: string;
  partnerCanEdit?: boolean;
};

export type ProductItem = {
  _id?: string;
  label: string | number;
  value: number;
  max?: number;
  type?: string;
};

export type ProductDetail = {
  name: string;
  delay: number;
  isActive: boolean;
  _id: string;
  state: TriStateEnum;
  items: ProductItem[];
  tableId?: string;
  createLink?: boolean;
  label?: string;
  subtitle?: string;
  description?: string;
  image?: string;
  imageBlack?: string;
  color?: string;
  coopId?: number | null;

  externalData?: IExternalProduct;
};

export type ProductsDetails = {
  [key in PartnerType]: ProductDetail;
};

export type ProductsConfigResponseNew = {
  products: ProductsDetails;
} & Record<PartnerType, boolean>;

export async function getProductsConfig() {
  const { data } =
    await httpClient.get<ProductsConfigResponseNew>("config/products");

  return data;
}
